import { render, staticRenderFns } from "./ICN003-05_menu.vue?vue&type=template&id=e879e6bc&"
import script from "./ICN003-05_menu.vue?vue&type=script&lang=js&"
export * from "./ICN003-05_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports